var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomerService',{staticClass:"kiu-customer-service",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('header',{staticClass:"kiu-customer-service__header"},[_vm._v("Fragen oder Wunschtermin?")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }